import {
  createElem,
  settingsList,
  createAndAssignOptions,
  createField, changeDivInner,
  optionRow, addElement,
  createH3Label,
  deleteOption
} from './util/form_fields.js';

var createItem;
$( document ).on('turbo:load', function () {
    if ($('.switchBox').length > 0) {
        $('.switchBox').bootstrapSwitch({onColor: 'success', offColor: 'warning'});
        $('.bootstrap-switch').css('vertical-align', 'bottom');
    }
    if ($('#settings').length > 0) {
        if($('.settings_row').length > 0){
            $('#settings').collapse('show');
        }
        var settingsCount = $('#settings').data('settings_count');
        createItem = function createItem() {
            if ($('#h3_settings').length <= 0) {
                var h3 = createH3Label('Settings', 'h3_settings');
                addElement('settings', h3);
            }
            var wrapper = optionRow();
            var row = createElem('div', ['row']);
            $(row).addClass('settings_row');
            var firstCol = createElem('div', ['col-sm-4']);
            var secondCol = createElem('div', ['col-sm-7']);
            var selectLabel = createElem('label');
            selectLabel.innerText = 'Setting';
            var settingsSettingHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#settings').data('setting-help')});
            $(firstCol).append(selectLabel);
            $(firstCol).append(' ');
            $(firstCol).append(settingsSettingHelpIcon);
            var settings = settingsList($('#settings_container').data('settings_list'));
            var select = createElem('select', ['form-control']);
            createAndAssignOptions(settings, select);
            $(firstCol).append(select);
            var label = createElem('label');
            label.innerText = 'Value';
            $(select).on('change', function () {
                var resultItem = createField($(this).val());
                changeDivInner(secondCol, resultItem);
            });
            var resultItem = createField($(select).val());
            changeDivInner(secondCol, resultItem);
            $(row).append(firstCol);
            $(row).append(secondCol);
            $(wrapper).append(row);
            $('#settings_container').append(wrapper);
            settingsCount++;
        }


        $('#add_setting').on('click', function(e) {
            e.preventDefault();
            createItem();
        });

        $('#settings_container').on('click', 'button.close.delete-option', function(e) {
            e.preventDefault();
            deleteOption(this);
        });
    }
});
